/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { BackButton as RebrandBackButton, Colors, Heading, HeadingLevel, Typography, } from '@zapier/design-system';
import NavDots from './NavDots';
import Feedback from './Feedback';
const Styles = {
    backButton: {
        // Prevent the back button from stretching across the container.
        marginRight: 'auto',
    },
    inner: {
        display: 'grid',
        gridGap: 20,
        gridTemplateColumns: '1fr min-content',
    },
    root: {
        display: 'grid',
        gridGap: 20,
    },
    stepTitle: Object.assign(Object.assign({}, Typography.sectionHeader3), { color: Colors.gray }),
    rebrandStepTitle: Object.assign(Object.assign({}, Typography.pageHeader9), { color: Colors.neutral800 }),
};
/**
  Wraps the content for each step of the contact form.
  Displays a title and numbered dots that can be used to navigate to previous steps.
  Optionally displays a feedback form beneath the content of the step.
*/
const HelpBlock = ({ children, currentStepIndex, dotTooltips, onClickHelpCenterLink, onClickNoWhatsNext, onGoBack, onGoForward, onGoToStep, showFeedback, title, size = 'large', }) => {
    const showDots = dotTooltips.length > 1;
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: Styles.backButton },
            isolateComponent(RebrandBackButton, { onClick: onGoBack }, "Back")),
        isolateComponent("div", { css: Styles.inner },
            isolateComponent(Heading, { css: Styles.rebrandStepTitle }, title),
            showDots && (isolateComponent(NavDots, { activeDotIndex: currentStepIndex, onDotClick: onGoToStep, tooltips: dotTooltips }))),
        isolateComponent(HeadingLevel, null, children),
        showFeedback && (isolateComponent(Feedback, { key: title, onClickHelpCenterLink: onClickHelpCenterLink, onClickNoWhatsNext: onClickNoWhatsNext, onGoToNextStep: onGoForward, size: size }))));
};
export default HelpBlock;
